<template>
  <section>
    <box-default>
      <div>
        <modal-open-log-user :dataCompanyModal="dataCompanyModal"/>
      </div>

      <full-loading v-if="loadingUser"/>
      <box-list-filter v-else title="Log de saldo" btn-back="true" route-btn-back="/log-de-saldo-por-funcionario">
        <div class="col-md-12 log-user">
          <div class="log-user-detail">
            <div class="log-user-detail-content">
              <span class="header-log">
                {{ dataUserList.name }} <b> - {{ dataUserList.email }}</b>
              </span>
              <div class="body-log">
                <div>
                  <span>
                    Data de Admissão: <b>{{ dataUserList.admissionDate | formatDate }}</b>
                  </span>
                  <span>
                    Código: <b>#{{ dataUserList.code }}</b>
                  </span>
                  <span>
                    Ativo:
                    <span v-if="dataUserList.active"><b>SIM</b></span>
                    <span v-else><b>NÃO</b></span>
                  </span>
                </div>
                <div>
                  <span v-if="dataUserList.personalInfo.cpf">
                    CPF:
                    <b>{{ dataUserList.personalInfo.cpf | cpfOrCnpj }}</b>
                  </span>
                  <span>
                    Camera: <b>{{ dataUserList.appCameraNumber }}</b>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="log-user-btn">
            <btn-default @emit-click="seeHref(1)" :label="'Ver perfil no master'"
                         :background="'#2F23D6'" :background-hover="'#352DA5'"
                         :color="'#FFFFFF'" width="100%"/>
            <btn-default @emit-click="seeHref(2)" :label="'Ver log de registros'"
                         :background="'#2F23D6'" :background-hover="'#352DA5'"
                         :color="'#FFFFFF'" width="100%"/>
          </div>
        </div>
        <datapicker-global col="3" variable-name="actionDate"
                           have-range-days-max="false" range-days-init="20"
                           label="Periodo da ação inicial/final"/>
        <datapicker-global col="3"
                           variable-name="affectedDate"
                           have-range-days-max="false"
                           range-days-init="20" label="Periodo afetado inicial/final"/>
        <input-select @selectedOption="value => dataSearch.type = value" col="3" :options="select"
                      label="Tipo de ação"/>
        <input-text @contentText="value => dataSearch.userName = value" col="3" type="text" placeholder="Digite um ID"
                    label="Feito por"/>
        <btn-search @emit-click="getBalance()" label="Pesquisar"/>
      </box-list-filter>

      <waiting-list :loading-content="loadingList">
        <box-listing v-if="researched" title="Log de saldo"
                     :columns-list-header="contentList.listHeader" :emptyState="emptyStateStatus">
          <template>
            <tr class="list-user" v-for="(c, index) in contentList.listBody" :key="index">
              <td>{{ c.createdAt | formatFullDate }}</td>
              <td>{{ c.balanceTimelineTypeStr }}</td>
              <td>{{ c.pointReference | formatDate }}</td>
              <td>{{ c.oldValue }}</td>
              <td>{{ c.newValue }}</td>
              <td>{{ c.createdByName }}</td>
              <td class="actions-user">
                <button v-if="c.grouped.length" v-on:click="openModalLogUser(c)">
                  <ion-icon name="ellipsis-horizontal"></ion-icon>
                </button>
              </td>
            </tr>
          </template>
        </box-listing>
      </waiting-list>
    </box-default>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import modalOpenLogUser from "../../modals/modalOpenLogUser.vue";
import swal from "sweetalert";

import {
  GET_BALANCE,
  GET_SELECT_BOX,
  USER_PERFIL,
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import BtnDefault from "../../components/buttons/btnDefault.vue";
import DatapickerGlobal from "../../components/inputs/datapickerGlobal.vue";
import BoxDefault from "../../components/layouts/boxDefault.vue";
import BoxListFilter from "../../components/layouts/boxListFilter.vue";
import InputSelect from "../../components/inputs/inputSelect.vue";
import InputText from "../../components/inputs/inputText.vue";
import BtnSearch from "../../components/buttons/btnSearch.vue";
import BoxListing from "../../components/layouts/boxListing.vue";
import WaitingList from "../../components/layouts/waitingList.vue";

export default {
  name: "log-de-saldo",
  components: {
    WaitingList,
    BoxListing,
    BtnSearch,
    InputText,
    InputSelect,
    BoxListFilter,
    BoxDefault,
    DatapickerGlobal,
    BtnDefault,
    topMenu,
    pageHeader,
    fullLoading,
    modalOpenLogUser,
  },
  data() {
    return {
      loadingUser: false,
      loadingList: false,
      failRequest: false,
      showList: true,
      researched: false,
      emptyStateStatus: false,
      dataCompanyModal: "",
      contentList: {
        listHeader: [
          'Data da ação',
          'Ação',
          'Dia afetado',
          'Saldo antes',
          'Saldo depois',
          // 'Acumulado',
          'Feito por',
          'Ações',
        ],
        listBody: [],
      },
      select: [
        {
          id: '',
          name: 'Selecione'
        }
      ],
      context: this.$route.params.contentSetting,
      dataSearch: {
        type: '',
        userName: '',
        userId: ''
      },
      dataUserList: {
        personalInfo: {
          cpf: "",
        },
      },
    };
  },
  methods: {
    seeHref(type) {
      if (type === 1) {
        window.open('/usuario/' + this.$route.params.userId + '/' + this.$route.params.contentSetting, "_blank");
      }
      if (type === 2) {
        window.open('/log-armazenados/', "_blank");
      }
    },
    openModalLogUser(data) {
      this.dataCompanyModal = data;

      $("#modalOpenLogUser").modal();
    },
    getBalance() {
      if (this.$route.params.actionDateInit && this.$route.params.actionDateEnd && this.$route.params.affectedDateInit && this.$route.params.affectedDateEnd) {
        this.loadingList = true;
        this.researched = true;

        let url = GET_BALANCE;

        url += "?userId=" + this.$route.params.userId;
        url +=
          "&actionInit=" + this.$route.params.actionDateInit;
        url +=
          "&actionEnd=" + this.$route.params.actionDateEnd;
        url +=
          "&affectedInitDate=" + this.$route.params.affectedDateInit;
        url +=
          "&affectedEndDate=" + this.$route.params.affectedDateEnd;
        if (this.dataSearch.type)
          url += "&type=" + this.dataSearch.type;
        if (this.dataSearch.userName)
          url += "&whoCreatedId=" + this.dataSearch.userName;

        REQUEST_SERVICE.requestContext("GET", url, this.context)
          .then((response) => {
            UTIL_SERVICE.console("RESULT GET_BALANCE:", response.data);

            this.contentList.listBody = response.data;

            if (this.contentList.listBody.length > 0) {
              this.emptyStateStatus = false
            } else {
              this.emptyStateStatus = true
            }

            this.loadingList = false;
            this.failRequest = false;
          })
          .catch((reason) => {
            this.loadingList = false;
            this.failRequest = true;
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      } else {
        swal("Aviso", "Preencha os campos para pesquisar", "error");
      }
    },
    getSelectBox() {
      let url = GET_SELECT_BOX;
      REQUEST_SERVICE.requestContext("GET", url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_SELECT_BOX:", response.data);

          this.select.push(...response.data);
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    getUser() {
      this.loadingUser = true;
      REQUEST_SERVICE.requestContext(
        "GET",
        USER_PERFIL + "?t=kkkk&i=" + this.$route.params.userId,
        this.context
      )
        .then((response) => {
          UTIL_SERVICE.console("RESULT USER_PERFIL:", response.data);

          this.dataUserList = response.data;

          this.loadingUser = false;
        })
        .catch((reason) => {
          this.loadingUser = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
  },
  beforeMount() {
    this.getSelectBox();
    this.getUser();
  },
};
</script>

<style lang="scss" scoped>

.log-user {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #E6E9EC;
  margin-bottom: 20px;

  &-detail {
    max-width: 70%;

    &-content {
      display: flex;
      flex-direction: column;

      .header-log {
        font-size: 28px;
        font-weight: 700;

        b {
          font-weight: 400;
        }
      }

      .body-log {
        display: flex;
        flex-direction: row;
        margin-top: 10px;

        div {
          display: flex;
          flex-direction: column;
          margin-right: 20px;

          span {
            font-weight: 400;
            font-size: 14px;
            color: #191919;
            margin-bottom: 10px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }

  &-btn {
    display: flex;
    flex-direction: column;
    padding-top: 3px;

    .button {
      padding: 0;

      &:first-child {
        margin-bottom: 10px;
      }
    }
  }
}

.list-user {
  td {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
    font-weight: 400;
    font-size: 16px;
    color: #3A424E;
    vertical-align: inherit !important;
  }

  .actions-user {
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background: #2F23D6;
      border-radius: 4px !important;
      height: 32px;
      width: 44px;
      transition: .2s;

      &:hover {
        background: #352DA5;
      }

      ion-icon {
        font-size: 20px;
        color: #FFFFFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/logPoint/logWorkingBalance.vue